import { render, staticRenderFns } from "./Dashboards.vue?vue&type=template&id=3df561e6"
import script from "./Dashboards.vue?vue&type=script&lang=ts"
export * from "./Dashboards.vue?vue&type=script&lang=ts"
import style0 from "./Dashboards.vue?vue&type=style&index=0&id=3df561e6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports